import React, { ComponentProps } from "react";
import { cn } from "@/shared/lib/utils";

export const H1 = ({ ref, className, ...props }: ComponentProps<"h1">) => {
  return (
    <h1
      ref={ref}
      className={cn("text-xl leading-[30px] font-bold", className)}
      {...props}
    />
  );
};

export const H2 = ({ ref, className, ...props }: ComponentProps<"h2">) => {
  return (
    <h2
      ref={ref}
      className={cn("text-xl leading-5 font-bold", className)}
      {...props}
    />
  );
};

// Subheading 1
export const H3 = ({ ref, className, ...props }: ComponentProps<"h3">) => {
  return (
    <h3
      ref={ref}
      className={cn("text-base leading-5 font-bold", className)}
      {...props}
    />
  );
};

export const H4 = ({ ref, className, ...props }: ComponentProps<"h4">) => {
  return (
    <h4
      ref={ref}
      className={cn("text-xs leading-5 font-medium", className)}
      {...props}
    />
  );
};

// TODO: i this should be h4 and current h4 should be h5 i think
export const H4XL = ({ ref, className, ...props }: ComponentProps<"h5">) => {
  return (
    <h5
      ref={ref}
      className={cn("text-sm leading-5 font-medium", className)}
      {...props}
    />
  );
};

// Body
export const Text = ({ ref, className, ...props }: ComponentProps<"p">) => {
  return (
    <p ref={ref} className={cn("text-sm leading-5", className)} {...props} />
  );
};

export const SubText = ({ ref, className, ...props }: ComponentProps<"p">) => {
  return (
    <p ref={ref} className={cn("text-xs leading-5", className)} {...props} />
  );
};

export const Body2 = ({ ref, className, ...props }: ComponentProps<"p">) => {
  return (
    <p ref={ref} className={cn("font-normal text-xs", className)} {...props} />
  );
};

export const Body = ({ ref, className, ...props }: ComponentProps<"p">) => {
  return (
    <p ref={ref} className={cn("font-normal text-sm", className)} {...props} />
  );
};
